import { render, staticRenderFns } from "./actions-table.vue?vue&type=template&id=d038ebc4&"
import script from "./actions-table.vue?vue&type=script&lang=js&"
export * from "./actions-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports